import * as React from 'react';
import { Modal } from 'semantic-ui-react';

import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import { OnboardingStatus, Permission } from '../../types';

import './OnboardingPopup.scss';

interface OnboardingPopupContentProps {
  country: string;
  onClose: () => void;
  permissions: Set<Permission>;
  status: OnboardingStatus;
  onOpenWorkday: () => void;
}

export const OnboardingPopupContent = ({ country, onClose, status, onOpenWorkday }: OnboardingPopupContentProps) => {
  const handleClickOpenWorkday = () => {
    onOpenWorkday();
    onClose();
  };

  if (status === 'INVITE_APPROVED') {
    return (
      <>
        <Modal.Header>
          <FormattedMessageHelper id="onboardingPopup.inviteApproved.title" />
        </Modal.Header>
        <Modal.Content>
          <div className="onboarding-popup__modal--content">
            <div className="onboarding-popup__modal--content--text">
              <FormattedMessageHelper id="onboardingPopup.inviteApproved.text" />
            </div>
            <div className="onboarding-popup__modal-section--buttons">
              <button onClick={handleClickOpenWorkday} className="button button--md  button--primary">
                <FormattedMessageHelper id="onboardingPopup.inviteApproved.button" />
              </button>
            </div>
          </div>
        </Modal.Content>
      </>
    );
  }

  if (status === 'QUESTIONNAIRE_APPROVED') {
    return (
      <>
        <Modal.Header>
          <FormattedMessageHelper id="onboardingPopup.questionnaireApproved.title" />
        </Modal.Header>
        <Modal.Content>
          <div className="onboarding-popup__modal--content">
            <div className="onboarding-popup__modal--content--text">
              <FormattedMessageHelper id="onboardingPopup.questionnaireApproved.text" />
            </div>
            <div className="onboarding-popup__modal-section--buttons">
              <button onClick={handleClickOpenWorkday} className="button button--md  button--primary">
                <FormattedMessageHelper id="onboardingPopup.questionnaireApproved.button" />
              </button>
            </div>
          </div>
        </Modal.Content>
      </>
    );
  }

  if (status === 'BACKGROUND_CHECK_APPROVED') {
    return (
      <>
        <Modal.Header>
          <FormattedMessageHelper id="onboardingPopup.backgroundCheckApproved.title" />
        </Modal.Header>
        <Modal.Content>
          <div className="onboarding-popup__modal--content">
            <div className="onboarding-popup__modal--content--text">
              <FormattedMessageHelper id="onboardingPopup.backgroundCheckApproved.text" />
            </div>
            <div className="onboarding-popup__modal-section--buttons">
              <button onClick={handleClickOpenWorkday} className="button button--md  button--primary">
                <FormattedMessageHelper id="onboardingPopup.backgroundCheckApproved.button" />
              </button>
            </div>
          </div>
        </Modal.Content>
      </>
    );
  }

  return <></>;
};
